import { ComponentTypes, PanelProps, PanelStyles, Tabset, TabsetProps, TabStyle } from "@mcleod/components";
import { StickyComponent } from "../sticky/StickyComponent";
import { AppStickyManager } from "../sticky/AppStickyManager";

export class AppTabset extends Tabset implements TabsetProps {
    private _originalTabStyle: TabStyle;

    constructor(props: Partial<TabsetProps>) {
        super(props);
        this.tabContainer._element.classList.add(PanelStyles.hideScroll);
    }

    protected override get tabContainerProps(): Partial<PanelProps> {
        return { ...super.tabContainerProps, scrollX: true };
    }

    protected override get tabRowProps(): Partial<PanelProps> {
        return { ...super.tabRowProps, wrap: false, paddingTop: 4, paddingBottom: 4 };
    }

    override get tabStyle(): TabStyle {
        return super.tabStyle;
    }

    override set tabStyle(value: TabStyle) {
        // Overridden because we never want scrollable tab styles in mobile.
        this._originalTabStyle ??= value;

        if (this._designer == null && value === TabStyle.SCROLL) {
            super.tabStyle = TabStyle.UNDERLINED;
            this.setShadowEffect(true);
        } else {
            super.tabStyle = value;
        }
    }

    public get originalTabStyle(): TabStyle {
        return this._originalTabStyle;
    }

    // stickyComponent getter property defined for Component class by AppComponent#initialize.
    // Used in AppStickyManager.
    get stickyComponents(): StickyComponent[] {
        if (this.tabStyle === TabStyle.ACCORDION)
            return null;
        else if (this.isVertical()) {
            return null; // StickyComponents are only for sticking to the top of the screen.
        }
        return [{
            element: this._header._element,
            contentComponent: this,
            onRegistration: (manager: AppStickyManager) => {
                this.addAfterTabSelectionListener(() => {
                    manager.unstickAllComponents();
                });
            }
        }];
    }
}

ComponentTypes.registerAppComponentType("tabset", {
    constructor: AppTabset.prototype.constructor
});
